import { useLocation } from 'react-router';
import { useAnalytics } from '~/hooks/useAnalytics';
import { AnalyticsEvents } from '~/services/analytics';

// Groups of path prefixes that belong to the same sidebar section.
// The Banks item links to /accounts, /transactions, and /reconciliations.
// The Invoices item links to /invoices and /counterparts.
// All other sections map 1:1 to their own prefix.
const SIDEBAR_SECTION_GROUPS: string[][] = [
  ['/accounts', '/transactions', '/reconciliations'],
  ['/invoices', '/counterparts'],
  ['/outstanding'],
  ['/cashflow'],
  ['/bookkeeping'],
  ['/settings'],
  ['/referral'],
  ['/f24'],
];

const getTopLevelPrefix = (path: string): string => {
  const segment = path.split('/')[1];
  return segment ? `/${segment}` : '/';
};

const isSameSection = (path1: string, path2: string): boolean => {
  const prefix1 = getTopLevelPrefix(path1);
  const prefix2 = getTopLevelPrefix(path2);
  if (prefix1 === prefix2) return true;
  return SIDEBAR_SECTION_GROUPS.some((group) => group.includes(prefix1) && group.includes(prefix2));
};

export const useTrackNavigation = () => {
  const { track } = useAnalytics();
  const currentPath = useLocation().pathname;

  const trackNavigation = (source: 'tabs' | 'sidebar', newPath: string) => {
    track(AnalyticsEvents.NAVIGATION_SECTION_CLICKED, {
      currentPath,
      isSameSection: isSameSection(currentPath, newPath),
      newPath,
      source,
    });
  };

  return trackNavigation;
};
